<script>
  import { StCrossTick } from '@st-graphics/icons'

  let { data = [], query = $bindable(''), suggestions = $bindable([]) } = $props()
  let isFocused = $state(false)

  // Filter unique names
  const estateNames = $derived(
    Array.from(new Set(data.map((d) => d['bto-name'])))
      .filter(Boolean)
      .sort(),
  )

  $effect(() => {
    if (query.trim() === '') {
      suggestions = estateNames
    } else {
      suggestions = estateNames.filter((name) => name.toLowerCase().includes(query.toLowerCase()))
    }
  })

  const selectSuggestion = (suggestion) => {
    query = suggestion
    isFocused = false
  }

  const selectRandom = () => {
    if (estateNames.length > 0) {
      const randomIndex = Math.floor(Math.random() * estateNames.length)
      query = estateNames[randomIndex]
    }
  }
</script>

<div class="search-container">
  {#if isFocused && suggestions.length > 0}
    <ul class="suggestions">
      {#each suggestions as suggestion (suggestion)}
        <li>
          <button onclick={() => selectSuggestion(suggestion)}>{suggestion}</button>
        </li>
      {/each}
    </ul>
  {/if}
  <input
    type="text"
    bind:value={query}
    placeholder="Search an estate name..."
    onfocus={() => (isFocused = true)}
    onblur={() => setTimeout(() => (isFocused = false), 200)}
  />
  {#if query.trim() !== ''}
    <button class="clear-btn" aria-label="Clear search" onclick={() => (query = '')}>
      <StCrossTick />
    </button>
  {/if}
</div>

{#if query.trim() === ''}
  <div class="random-option">
    <button onclick={selectRandom}>Or show me a random name</button>
  </div>
{/if}

<style lang="scss">
  .search-container {
    position: relative;
    width: 100%;
  }

  input {
    width: 100%;
    padding: 5px 40px 5px 20px;
    border-radius: 10px;
    border: 1px solid #fff;
    background: transparent;
    color: white;
    font-size: 16px;
    font-weight: 300;
    outline: none;
    font-family: var(--font-sans-serif);
    transition: border-color 0.2s ease;

    &:focus {
      border-color: var(--project-highlight-color, #cfff5e);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
      font-weight: 300;
    }
  }

  .clear-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    opacity: 0.6;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }
  }

  .suggestions {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    background: #263d8b;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    margin-bottom: 8px;
    list-style: none;
    padding: 8px 0;
    max-height: 260px;
    overflow-y: auto;
    z-index: 100;

    li button {
      width: 100%;
      text-align: left;
      padding: 10px 20px;
      background: transparent;
      border: none;
      color: white;
      font-size: 14px;
      cursor: pointer;
      font-family: var(--font-sans-serif);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: var(--project-highlight-color, #cfff5e);
      }
    }
  }

  .random-option {
    margin-top: 12px;
    text-align: left;

    button {
      background: transparent;
      border: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      font-family: var(--font-sans-serif);
      cursor: pointer;
      padding: 0;
      border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
      transition: all 0.2s ease;
      line-height: 1.2;

      &:hover {
        color: white;
        border-bottom-color: white;
      }
    }
  }
</style>
